import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans du Support chargés à la demande (budget d'affichage SC-003).
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const pages = () => import('./SupportPages.js');
const RequestsPage = page(pages, 'RequestsPage');
const RequestPage = page(pages, 'RequestPage');
const AdminPage = page(pages, 'AdminPage');
const ReportPage = page(pages, 'ReportPage');
const MyRequestsPage = page(pages, 'MyRequestsPage');
const IndicatorsPage = page(pages, 'IndicatorsPage');
const MacrosPage = page(pages, 'MacrosPage');

/** Routes du module Support (module.json `navigation`, T023). */
export const supportWeb: ModuleWeb = {
  module: 'support',
  routes: [
    { path: '/support/demandes', element: <RequestsPage /> },
    { path: '/support/demandes/:id', element: <RequestPage /> },
    { path: '/support/admin', element: <AdminPage /> },
    { path: '/support/remontee', element: <ReportPage /> },
    { path: '/support/mes-demandes', element: <MyRequestsPage /> },
    { path: '/support/indicateurs', element: <IndicatorsPage /> },
    { path: '/support/reponses-types', element: <MacrosPage /> },
  ],
};
